import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { buildQueryString } from 'utils/jsUtils';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useNewCachedFlowRun = ({
  crId,
  runId,
  startLevelID,
  pauseLevelID,
  branches,
  excludeNodesWithoutTags,
  includeMismatchingTaggedNodes,
}) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  // Build query params for filtering
  const queryParams = {};
  if (startLevelID) queryParams.startLevelID = startLevelID;
  if (pauseLevelID) queryParams.pauseLevelID = pauseLevelID;
  if (branches) queryParams.branches = branches;
  if (excludeNodesWithoutTags) {
    queryParams.excludeNodesWithoutTags = excludeNodesWithoutTags;
  }
  if (includeMismatchingTaggedNodes) {
    queryParams.includeMismatchingTaggedNodes = includeMismatchingTaggedNodes;
  }
  // Always include cached parameters from levels below start level
  queryParams.includeCachedBelowStart = true;

  const queryString = buildQueryString(queryParams);
  const url = `${flow(orgId).newCachedFlowRun(crId, runId)}${queryString}`;

  const {
    data, isLoading, isSuccess, isError,
  } = useQuery({
    queryKey: ['Fetch-New-Cached-Flow-Run', crId, runId, startLevelID, pauseLevelID, branches, excludeNodesWithoutTags, includeMismatchingTaggedNodes],
    queryFn: async () => axiosInstance.get(url),
    onError: (error) => dispatch(
      showAlert({
        message: error.response?.data?.message || 'Error fetching initial data for new cached flow run',
        type: 'error',
      })),
  });

  return {
    isLoading,
    isError,
    isSuccess,
    data,
  };
};
